module.exports = __webpack_public_path__ + "img/comp_clover.22f72145.png";